import { render, staticRenderFns } from "./SettingsEvents.vue?vue&type=template&id=64b14e74&scoped=true&"
import script from "./SettingsEvents.vue?vue&type=script&lang=ts&"
export * from "./SettingsEvents.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64b14e74",
  null
  
)

export default component.exports